import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), origin: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <form className="auth-card fade-up" onSubmit={onSubmit}>
        <div style={{ display: "flex", justifyContent: "center" }}><Logo height={84} /></div>

        {sent ? (
          <div style={{ textAlign: "center", marginTop: 20 }} data-testid="forgot-sent">
            <CheckCircle2 size={40} style={{ color: "var(--brand)" }} />
            <h2 style={{ fontSize: 20, marginTop: 10 }}>Check your email</h2>
            <p className="ss-muted" style={{ marginTop: 6 }}>
              If an account exists for <b>{email.trim()}</b>, we've sent a link to reset your password. The link expires in 1 hour.
            </p>
            <button type="button" className="ss-btn ss-btn-ghost ss-btn-block" style={{ marginTop: 20 }} onClick={() => navigate("/login")} data-testid="back-to-login-button">
              <ArrowLeft size={16} /> Back to login
            </button>
          </div>
        ) : (
          <>
            <p className="ss-muted" style={{ textAlign: "center", marginTop: 8 }}>
              Enter your email and we'll send you a link to reset your password.
            </p>
            <div style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 14 }}>
              <div className="ss-field">
                <Mail size={18} className="ss-muted" />
                <input type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
              </div>
              {error && <div style={{ color: "var(--red)", fontWeight: 600, fontSize: 14 }} data-testid="forgot-error">{error}</div>}
              <button className="ss-btn ss-btn-primary ss-btn-block" disabled={loading} data-testid="forgot-submit-button">
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </div>
            <div style={{ textAlign: "center", marginTop: 18 }}>
              <span style={{ color: "var(--brand)", fontWeight: 700, cursor: "pointer", fontSize: 14 }} onClick={() => navigate("/login")} data-testid="back-to-login-link">
                <ArrowLeft size={14} style={{ display: "inline", verticalAlign: "middle" }} /> Back to login
              </span>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
